import { Box, CircularProgress, Dialog } from "@mui/material";
import React from "react";

interface ImageZoomDialogProps {
	open: boolean;
	onClose: () => void;
	/** Object URL of the picture; empty while its bytes are still loading. */
	src: string;
	alt: string;
}

/**
 * A picture, as large as the window allows, and nothing else.
 *
 * The dialog sizes itself to the image (no `fullWidth`, no fixed height), so
 * there is no frame around it and no empty space under it; a click anywhere
 * closes it. Release-note images and ticket screenshots open through this.
 */
const ImageZoomDialog: React.FC<ImageZoomDialogProps> = ({
	open,
	onClose,
	src,
	alt,
}) => (
	<Dialog
		data-component="image-zoom-dialog"
		open={open}
		onClose={onClose}
		maxWidth={false}
	>
		<Box
			data-component="image-zoom-content"
			onClick={onClose}
			sx={{ overflow: "auto", cursor: "zoom-out", lineHeight: 0 }}
		>
			{src ? (
				<Box
					component="img"
					src={src}
					alt={alt}
					sx={{ display: "block", maxWidth: "100%" }}
				/>
			) : (
				<Box sx={{ p: 4 }}>
					<CircularProgress />
				</Box>
			)}
		</Box>
	</Dialog>
);

export default ImageZoomDialog;
